import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { FileStatusLabel } from '../../file-status-label';

import Global from '../../../../../../store/global-selectors';
import { exportProductsRequest } from '../../../../../../store/products/grid/product.grid.actions';
import { CHOOSE_EXPORT_DIALOGUE, EXPORT_IN_PROGRESS_DIALOGUE } from '../../../../../products-page/products/constants/export-products';

import messages from '../../messages';
import commonStyles from '../../../style.module.less';
import style from '../../style.module.less';

const ExportCsvStep = () => {
  const dispatch = useDispatch();
  const exportProductsStarted = useSelector(Global.selectProductproductExportStarted);
  const exportProductsComplete = useSelector(Global.selectProductproductExportCompleted);

  const [modalDialogue, setModalDialogue] = useState(CHOOSE_EXPORT_DIALOGUE);

  const onExportClick = useCallback(() => {
    const productIds = null; // EXPORT ALL
    const searchTerm = ''; // no search terms
    const filters = []; // no filters
    dispatch(exportProductsRequest(searchTerm, filters, productIds));
    setModalDialogue(EXPORT_IN_PROGRESS_DIALOGUE);
  }, [dispatch]);

  return (
    <div className={commonStyles['step-content']}>
      <Text className={style['step-title']} textType={TextType.H3} value={messages.createAProductFile} />
      <Text className={style['step-paragraph']} textType={TextType.Paragraph} value={messages.directionsForCreatingAProductFile1} />
      <ol className={classnames(commonStyles['auto-routing-bulleted-list'], style['auto-routing-wizard-list'])}>
        <li className={commonStyles['.auto-routing-numbered-list-item']}>
          <Text
            formattedMessageValues={{
              b: (chunks) => <span className={commonStyles.bolded}>{chunks}</span>,
            }}
            textType={TextType.Paragraph}
            value={messages.directionsForCreatingAProductFileStep1}
          />
        </li>
        <li className={commonStyles['.auto-routing-numbered-list-item']}>
          <Text
            formattedMessageValues={{
              b: (chunks) => <span className={commonStyles.bolded}>{chunks}</span>,
            }}
            textType={TextType.Paragraph}
            value={messages.directionsForCreatingAProductFileStep2}
          />
        </li>
        <li className={commonStyles['.auto-routing-numbered-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.directionsForCreatingAProductFileStep3} />
        </li>
      </ol>
      <Text
        className={style['step-paragraph']}
        formattedMessageValues={{
          b: (chunks) => <span className={commonStyles.bolded}>{chunks}</span>,
        }}
        textType={TextType.Paragraph}
        value={messages.directionsForCreatingAProductFile2}
      />
      {modalDialogue === CHOOSE_EXPORT_DIALOGUE && (
        <Button className={style['submit-button']} onClick={onExportClick} theme='primary'>
          <FormattedMessage {...messages.exportProductCSVButtonLabel} />
        </Button>
      )}
      {modalDialogue === EXPORT_IN_PROGRESS_DIALOGUE && exportProductsStarted && (
        <Text textType={TextType.Caption} value={messages.productExportStartedDuringSetup} />
      )}
      {modalDialogue === EXPORT_IN_PROGRESS_DIALOGUE && exportProductsComplete && <FileStatusLabel />}
    </div>
  );
};

export default ExportCsvStep;
